import { render, staticRenderFns } from "./allTraining.vue?vue&type=template&id=2126dc00"
import script from "./allTraining.vue?vue&type=script&lang=js"
export * from "./allTraining.vue?vue&type=script&lang=js"
import style0 from "./allTraining.vue?vue&type=style&index=0&id=2126dc00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports